module.exports = __webpack_public_path__ + "img/product-placeholder-50.ded41bf.png";